<template>
  <div class="service-info">
    <div class="transaction-summary">
      <h2 class="txn-details-label">Transaction Details</h2> 
      <div class="transaction-details">
        <div class="row">   
          <div class="col-1 title">
            <span>Transaction ID</span>
          </div>
          <div class="col-2 title">
            <span>Transaction Fee</span>
          </div>
          <div class="col-3 title txn-name">
            <span>Transaction Name</span>
          </div>
          <div class="col-4 title printDoc" v-if="registrationCertActive">
            <span>Documents for printing</span>
          </div>
        </div>
        <ul>
          <li class="row" v-for="(transactionDetails, index) in renewalCart" :key="index">
            <div class="col-1">
              <span>{{ cartTransactions[index]?.transactionData?.transactionId || '' }}</span>
            </div>
            <div class="col-2 txn-details total-charge text-right">
              <span>{{ toCurrencyNum(totalAmount(transactionDetails)) }}</span>                 
            </div>
            <div class="col-3 txn-details" :style="registrationCertActive ? '' : 'width:auto !important'">
              <span class="vehicle-reg-info"> {{ transactionDetails.description }}
                {{ transactionDetails.year }} {{ transactionDetails.make }}
                {{ transactionDetails.model !== 'UNKNOWN' ? transactionDetails.model : '' }}
                {{ transactionDetails.plateNumber }}
                <template v-if="transactionDetails.plateNumber || transactionDetails.plateType"> / {{ transactionDetails.plateType }}</template>
              </span>
            </div>
            <div class="col-4 txn-details" v-if="finalizationCartTransactions[index]?.transactionData?.isTransactionOutputDocument">
              <p class="btn-reg-cert">Documents are attached to the email sent to you. If email was not received use the 'Resend confirmation' button above.</p>
            </div>
          </li>
        </ul>
        <div class="row service-fee-row">
          <div class="col-1 service-fee">
            <span>Service Fee for the third party provider</span>
          </div>
          <div class="col-2 txn-details-service-fee text-right">
            <span>{{ toCurrencyNum(forteServiceFee) }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-1 total-bill">
            <span>Total bill</span>
          </div>
          <div class="col-2 total-amount text-right">
            <span>{{ toCurrencyNum(totalSumFeeAmount) }}</span>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>


<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { toCurrency } from '@/utils/helpers';
import * as COMMONS from '../../store/_commons';
import { useHead } from '@unhead/vue';
import appConfig from '@/app.config'

defineOptions({
  name: 'ServiceInfo',
});

// Use unhead to manage the page meta
useHead({
  title: `Documents for printing | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'Print or save your documents'
    }
  ]
});

// Vuex store
const store = useStore();

// Computed properties from Vuex state
const renewalCart = computed(() => store.state.guestLogin?.renewalCart || []);
const cartTransactions = computed(() => store.state.guestLogin?.cartTransactions?.cartTransactions || []);
const finalizationCartTransactions = computed(() => store.state.guestLogin?.finalizationCart?.finalizeCartResponse?.transactionCart?.cartTransactions || []);
const forteServiceFee = computed(() => store.state.guestLogin?.totalBill?.forteServiceFee || 0);
const totalSumFeeAmount = computed(() => store.state.guestLogin?.totalBill?.totalSumFeeAmount || 0);

const registrationCertActive = computed(() => {
  return finalizationCartTransactions.value.some(item => item.transactionData?.isTransactionOutputDocument);
});

// Methods
const toCurrencyNum = (value) => {
  return toCurrency(value);
};

const totalAmount = (txnFeesCart) => {
  let total = 0;
  
  const fees = txnFeesCart?.onlineTransactionFeeCollection;
  
  if (fees != null) {
    for (const obj of fees) {
      total += obj.feeAmount;
    }
  }  
  
  return total;   
};

// eslint-disable-next-line no-unused-vars
const handleRouting = (index) => {
  const txnId = cartTransactions.value[index]?.transactionData?.transactionId;

  let vehicleRegistrationId;
  
  for (let i = 0; i < store.state.guestLogin.VehicleRegIdTxnId.length; i++) {
    // This if statement depends on the format of array
    if (store.state.guestLogin.VehicleRegIdTxnId[i].transactionId  ==txnId) {
      vehicleRegistrationId = store.state.guestLogin.VehicleRegIdTxnId[i].vehicleRegistrationId // Found it
    }
  }

  store.state.guestLogin.selectRenewRegistartion.vehicleRegistrationId = vehicleRegistrationId;
  store.dispatch(COMMONS.GUEST_OUTPUT_DOCUMENT, vehicleRegistrationId);
};


</script>


<style scoped lang="scss">
.service-info {
  background-color: var(--ri-darker-blue);
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  color: white;
  padding: 2em 1em 0 1em;
  margin-bottom: calc(var(--padding-vertical) * 2);
  width: 52vw;
  max-width: 55vw;

  .text-right {
    text-align: right !important;
  }
  .transaction-summary {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    .txn-details-label {
      margin-bottom: 15px;
    }
    .transaction-details {
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
      .row {
        display: flex;
        margin-bottom: 1rem;
        font-size: 16px;
        gap: 1rem;
        .col-1, .col-2, .col-3, .col-4 {
          min-width: 125px;
        }
        .printDoc{
          width: 250px ;
        }
        .title {
          font-weight: 700;
          line-height: 24px;
          margin: 1rem 0;
        }
        .col-3 {
          width: 230px;
        }
        .total-amount {
          color: orange;
          font-weight: bold;
          text-align: right;
        }
        .service-fee {
          width: 100px;
        }
        .total-bill {  
          font-weight: bold;
          min-width: 125px;
        }
        .txn-details-service-fee {
          text-align: right;
        }
        .total-charge{
          text-align: right;
        }
        .col-4 {
          .print-docText{
            font-size: 12px;
            font-weight: 400;
            padding-bottom: 0em;
            padding-top: 0.2em;
            line-height: 1.2em;
          }
        }
      }
      .service-fee-row{
        width: 100%;
        margin-bottom: 1.5rem;
      }
      .btn-reg-cert{
        width: 200px;
        padding-top: 0em !important;
      }
    }
  }
  @media print {
    @page { 
      size: var(--themesize); 
    }
    background-color: var(--print-background);
    color: var(--print-font-color);
    font-size: 1rem;
    padding: 1em 0;
    max-width: unset;
    min-width: 700px;
    width: 115% !important;

    .transaction-summary {
      .transaction-details {
        .row {
          display: flex;
          gap: 2rem;
          .col-1, .col-2, .col-3 {
            min-width: 125px;
          }
          .col-4{
            display: none;
          }
          .service-fee {
            width: 100px;
          }
          .total-bill {  
            min-width: 125px;
          }
          .txn-details-service-fee {
            text-align: right;
          }
          .total-amount {
            text-align: right;
            color: black;
          }
          .total-charge{
            text-align: right;
          }
          .col-3 {
            width: 400px !important;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 516px) {
  .service-info{
    width: 100%;
    padding-right: 0px;
    max-width: 100%;
    .transaction-summary {
      .transaction-details {
        margin-right: 5px;
      }
      .row{
        display: block !important;
        margin-bottom: 1rem;
        .title {
          margin-right: 0.5rem;
        }
        .col-1, .col-2, .col-3, .col-4 {
          min-width: 100px !important;
          margin-bottom: 15px;
          text-align: left !important;
        }
        .total-bill {
          min-width: 100px !important;
        }
        .service-fee {
          width: 100px;
          min-width: 200px !important;
        }
        .txn-details-service-fee{
          text-align: right;
        }
        .total-charge{
          text-align: right;
        }
      }
      .btn-reg-cert{
        width: 90% !important;
        padding-top: 0em !important;
      }
    }
  }
}

@media only screen and (min-width: 517px) and (max-width: 898px) {
  .service-info{
    width: 100%;
    padding-right: 0px;
    max-width: 100%;
    .transaction-summary {
      .transaction-details {
        margin-right: 5px;
      }
      .row{
        display: flex;
        margin-bottom: 1rem;
        .title {
          margin-right: 0.5rem;
        }
        .col-1, .col-2, .col-3, .col-4 {
          margin-bottom: 15px;
        }
        .printDoc{
          width: 170px !important;
        }
        .col-3 {
          width: 175px !important;
        }
        .service-fee {
          width: 100px;
        }
        .txn-details-service-fee{
          text-align: right;
        }
        .total-charge{
          text-align: right;
        }
      }
    }
  }
}

@media only screen and (min-width: 899px) and (max-width: 1374px)  {
  .service-info{
    width: 100%;
    padding-right: 0px;
    max-width: 100%;

    .transaction-summary {
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
      .transaction-details {
        margin-right: 5px;
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
      }
      .row{
        display: flex;
        margin-bottom: 0.5rem;

        .col-1, .col-2, .col-3, .col-4, .total-bill, .service-fee {
          min-width: 19vw !important;
        }
        .printDoc{
          width: 170px !important;
        }
        .title {
          margin-right: 0.5rem;
        }
        .txn-details {
          margin-bottom: 1rem;
        }
        .service-fee {
          width: 100px;
          min-width: 19vw;
        }
        .total-bill {  
          min-width: 19vw;
          font-weight: bold;
        }
      }
      .service-fee-row{
        width: 100%;
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
